export const LeadStateTypeId = {
  1: 'Open',
  2: 'Won',
  3: 'Lost',
  4: 'Deleted',
};

export const LeadStateType = {
  Open: 1,
  Won: 2,
  Lost: 3,
  Deleted: 4,
};
